/**
 * Do not edit directly
 * Generated on Wed, 17 Apr 2024 09:25:51 GMT
 */

export const SDS_ZINDEX_DEEP = -999999; // Deep places an element at the back of the stacking order.
export const SDS_ZINDEX_HIDE = -1; // Hide keeps an element behind the surrounding elements.
export const SDS_ZINDEX_AUTO = "auto"; // auto allows element to follow the default stacking order.
export const SDS_ZINDEX_BASE = 1000; // Base defines the starting point for systematically stacking the elements.
export const SDS_ZINDEX_DROPDOWN = 2000; // Dropdown defines a stacking order of dropdown menu.
export const SDS_ZINDEX_NAVIGATION = 3000; // Navigation defines a stacking order of navigation element to keep the navigation menu on top.
export const SDS_ZINDEX_POPOVER = 4000; // Popover ensures that the popover element is above the other elements to prevent the overlap.
export const SDS_ZINDEX_NOTIFICATION = 5000; // Notification defines stacking order of notification element so that it can be placed on top.
export const SDS_ZINDEX_BLANKET = 6000; // Blanket defines a stacking order so that it should be placed above the all elements but behind Modal and Drawer.
export const SDS_ZINDEX_DRAWER = 7000; // Drawer defines the positioning of drawer element above enough to keep drawer visible in the interface.
export const SDS_ZINDEX_MODAL = 8000; // Modal is the top most element in element's stacking order.
